import { useState } from "react";
import { useTranslation } from "react-i18next";
import useEbayMessagesListing from "../../../data/useEbayMessagesListings";
import { IEbayMessage } from "../../../models/EbayMessage";
import { IPart } from "../../../models/Part";
import Card from "../Card/Card";
import LoadingWheel from "../LoadingWheel";
import LoadMessagesPrompt from "../LoadMessagesPrompt";
import EbayMessageChain from "../../ebayMessaging/EbayMessageChain";
import formatDateTime from "../../../utils/formatDateTime";
import { DateTime } from "luxon";

export default function EbayPartMessages({ part }: { part: IPart }) {
  //part.id="266554555829";
  const { t } = useTranslation("common");
  // A cancel, return or relist clears ebayItemNumber but the API falls back to the Trading API item id
  const hasEbayListing = !!(part.ebayItemNumber || part.ebayTradingApiItemId);
  const [loadRequested, setLoadRequested] = useState(false);
  const { messages } = useEbayMessagesListing({ part: part, enabled: loadRequested && hasEbayListing });
  const [chainOpen, setChainOpen] = useState(false);
  const [chosenMessage, setChosenMessage] = useState<IEbayMessage | undefined>();

  // Cached data from an earlier load is shown straight away
  const showLoadPrompt = !loadRequested && !messages.data;

  return (
    <Card title={t("eBay Messages")} bodyClassName={!hasEbayListing || showLoadPrompt ? "px-6 py-3" : "px-6 py-5"}>
      {
        !hasEbayListing ?
          <p className="text-sm text-gray-500">{t("Not listed on eBay")}</p> :
          showLoadPrompt ?
            <LoadMessagesPrompt onLoad={() => setLoadRequested(true)} /> :
            messages.isInitialLoading ?
              <LoadingWheel /> :
              <>
                <EbayMessageChain open={chainOpen} setOpen={setChainOpen} originMessage={chosenMessage} />
                <div className="flex-col">
                  {
                    messages.data?.data.length ?
                      messages.data?.data.map((message, i) => <div key={i} className="mb-2 hover:bg-slate-200 hover:underline cursor-pointer" onClick={() => { setChosenMessage(message); setChainOpen(true); }}>
                        <span className="underline"><span className="font-bold">{message.sendingUserID}</span> {formatDateTime(message.receiveDate, DateTime.DATETIME_SHORT)}</span>
                        <p className="">{message.body}</p>
                      </div>)
                      :
                      messages.isError ? <div><p>{t("Unable to retrieve messages")}</p></div> : <div><p>{t("No Messages")}</p></div>
                  }
                </div>
              </>
      }
    </Card>
  );
};
